import { KYMW6001Model } from '../kymw6001.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * CWS使用画像一覧表(全体)を取得する
 *
 * @export getCwsPlanGoodsUseImageGroupListService
 * @class GetCwsPlanGoodsUseImageGroupListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCwsPlanGoodsUseImageGroupListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW6001Model;
  private successFunc: Function;

  vo = {
      /** 受注コード */
      orderCode: '',
      /** 媒体区分 */
      mediumType: '',
      /** 配達企画回（翌週） */
      catalogId: '',
      /** 部門コード */
      classCode: '',
      /** Pコード */
      pCode: '',
      /** 特集コード */
      featureCode: '',
      /** マルチ・クロスフラグ */
      multiOrCrossFlg: '',
      /** 画像未指定 */
      imageNoUseFlag: '',
      /** 確認状況 */
      imageCheckFlag: ''
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCwsPlanGoodsUseImageGroupListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        CwsPlanGoodsUseImageList: {
          condition: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            CatalogId: this.vo.catalogId,
            ClassCode: this.vo.classCode,
            PCode: this.vo.pCode,
            FeatureCode: this.vo.featureCode,
            MultiOrCrossFlg: this.vo.multiOrCrossFlg,
            ImageNoUseFlag: this.vo.imageNoUseFlag,
            ImageCheckFlag: this.vo.imageCheckFlag,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCwsPlanGoodsUseImageGroupListService
   */
  execute(model: KYMW6001Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getCwsPlanGoodsUseImageGroupList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCwsPlanGoodsUseImageGroupListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
